import React from 'react';
import cssClass from './Offline.module.css';
import OfflineIcon from '../../Assets/Images/Common/no-internet-icon.svg';
const Offline = () => {
    return (
        <div className={cssClass.pageWrapper}>
            <div className={cssClass.imgWrapper}>
                <img src={OfflineIcon} alt="You are offline" />
                <p className={cssClass.title}>
                    You are Offline
                </p>
                <p className={cssClass.subtitle}>
                    Connect to a network and try again!
                </p>
            </div>
        </div>
    );
}

export default Offline;
